import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { LEGACY_ASSET_REDIRECTS } from "./lib/site";
import { attachSupabaseAuth } from "@/lib/attach-supabase-auth";

const legacyAssetMiddleware = createMiddleware().server(async ({ next, request }) => {
  if (request.method !== "GET" && request.method !== "HEAD") return next();
  const target = LEGACY_ASSET_REDIRECTS[new URL(request.url).pathname];
  if (!target) return next();
  return new Response(null, {
    status: 301,
    headers: {
      Location: target,
      "Cache-Control": "public, max-age=3600",
    },
  });
});

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // Managed email routes authenticate themselves — never wrap/redirect them.
  if (new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [legacyAssetMiddleware, errorMiddleware, csrfMiddleware],
}));
